import React, { useEffect, useState, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link, useHistory } from 'react-router-dom';
import { Row, Col, Form, Button, Table } from 'react-bootstrap';
import Select from 'react-select';
import Docmnt from "../../../../assets/images/file.svg";
import Trash from "../../../../assets/images/trash.png";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import { withRFSToken } from '../../../../Services/axios.js';
import { GETDESTINATION, GETOWNERCODE } from '../../../../Utils/conts.js';
import { toast } from 'react-toastify';
import { CallApi } from '../../../../Components/common/CommonFunctions.js';
const OrderDetails = () => {
    const isMounted = useRef(false);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState([]);
    const [formData, setFormData] = useState({ shipment: [] });
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const history = useHistory();

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData(prevFormData => {
            const newFormData = {
                ...prevFormData,
                [name]: type === 'checkbox' ? checked : value
            };
            return newFormData;
        });
    };

    useEffect(() => {
        if (isMounted.current) return;
        fetchOwnerCode();
        getAllDestination();
        isMounted.current = true;
    }, []);

    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA
                    })) : [];
                    setGetOwnerCode(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const getAllDestination = async () => {
        try {

            const res = await withRFSToken.post('trip-management/get-station-with-warehouses', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_Id,
                        label: item.code,
                        port_Id: item.port_Id,
                        station_users: item.station_users
                    })) : [];
                    setGetDestination(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const getHandlersByStation = (stationCode, handlerOrgId) => {
        const station = getDestination.find(s => s.label === stationCode);
        if (!station || !station.station_users) return [];
        return station.station_users
            // .filter(user => user.org_id === handlerOrgId)
            .flatMap(user =>
                (user.warehouses || []).map(warehouse => ({
                    value: warehouse.id,
                    label: warehouse.name,
                    org_id: user.org_id,
                    warehouse_id: warehouse.id,
                    station_user_id: user.id
                }))
            );
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;
        const existingBase64Files = formData?.base64Files || [];
        droppedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === droppedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);
            setFormData((prevFormData) => {
                const newFormData = { ...prevFormData, base64Files: newBase64Files };
                return newFormData;
            });
            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;
        const existingBase64Files = formData?.base64Files || [];
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const addShipment = () => {
        const newRow = {
            awb_no: '',
            uld_number: '',
            pieces: '',
            weight: '',
            volume: '',
            nature: '',
            flight_code: '',
            flight_number: '',
            flight_date: '',
        };
        const updatedFormData = [...formData.shipment, newRow];
        setFormData({
            ...formData,
            shipment: updatedFormData
        });
    };

    const removeShipment = (id) => {
        const updatedFormData = formData.shipment.filter((stack, index) => index !== id);
        setFormData({
            ...formData,
            shipment: updatedFormData
        });
    };

    const shipmentChange = (rowId, field, value) => {
        let updatedData = formData.shipment.map((item, index) => {
            if (index === rowId) {
                if (field === 'awb_no') {
                    value = handleChange(value);
                }
                const updatedItem = {
                    ...item,
                    [field]: value
                };
                return updatedItem;
            }
            return item;
        });
        setFormData({
            ...formData,
            shipment: updatedData
        });
    };

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, '');
        let formattedValue = '';
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }
        formattedValue += value;
        return formattedValue.substr(0, 13);
    };

    const submitForm = (value) => {
        CallApi({
            endPoint: 'rfs-order/save-data',
            payload: formData,
            onSuccess: (data) => {
                if (data.data.response_code === 200) {
                    toast.success(data.data.response_msg);
                    history.push('/TruckMonitor')
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    return (
        <>
            <div className="">
                <Header logo_url='/TruckMonitor' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className='main-panel'>
                        <Link to='/TruckMonitor' className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        <Row className='mt-2'>
                            <Col sm="4">
                                <div className='mb-3 nestedtabs rounded h-100'>
                                    <div className='charter_top'>
                                        <h3>Order Details</h3>
                                    </div>
                                    <div className='charter_from from_width order_details'>
                                        <Form.Group as={Row} className="mb-1" >
                                            <Col sm="6" className='pe-0'>
                                                <Form.Label>Truck Number <span>*</span></Form.Label>
                                                <div className='d-flex'>
                                                    <Select
                                                        options={getOwnerCodes}
                                                        onChange={(selected) => {
                                                            setFormData(prevFormData => {
                                                                const newFormData = { ...prevFormData, truck_code: selected.value };

                                                                return newFormData;
                                                            });
                                                        }}
                                                        placeholder="Code"
                                                        className='autoslct'
                                                        name="truck_code"
                                                        value={getOwnerCodes.find(option => option.value === formData.truck_code)}
                                                    />
                                                    <span>-</span>
                                                    <Form.Control
                                                        type="text" className='ms-2'
                                                        name='truck_number'
                                                        maxLength='8' onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 8); }}
                                                        value={formData.truck_number} onChange={handleInputChange}
                                                    />
                                                </div>
                                            </Col>
                                            <Col sm="6" >
                                                <Form.Label>Truck Date <span>*</span></Form.Label>
                                                <Form.Control type="date" name="truck_date" value={formData.truck_date} onChange={handleInputChange} />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" >
                                            <Col sm="6" className='pe-0'>
                                                <Form.Label>Boardpoint </Form.Label> {/* <span>*</span> */}
                                                <Select
                                                    options={getDestination}
                                                    onChange={(selected) => {
                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                        const handlerOptions = getHandlersByStation(selectedDestination.label, selectedDestination.value);
                                                        setSelectedOriginHandler(handlerOptions);
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, boardpoint: selected.label };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    placeholder="Origin"
                                                    className='autoslct'
                                                    name="origin"
                                                    value={getDestination.find(option => option.value === formData.boardpoint)}
                                                />
                                            </Col>
                                            <Col sm="6">
                                                <Form.Label>Boardpoint Handler Name </Form.Label>
                                                <Select
                                                    options={selectedOriginHandler}
                                                    onChange={(selected) => {
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, boardpoint_handler_id: selected.value, boardpoint_handler: selected.label };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    placeholder="Handler Name"
                                                    className='autoslct'
                                                    name="boardpoint_handler"
                                                    value={selectedOriginHandler?.find(option => option.value === formData.boardpoint_handler_id) || null}
                                                    isDisabled={!selectedOriginHandler?.length}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" >
                                            <Col sm="6" className='pe-0'>
                                                <Form.Label>Offpoint </Form.Label> {/* <span>*</span> */}
                                                <Select
                                                    options={getDestination}
                                                    onChange={(selected) => {
                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                        const handlerOptions = getHandlersByStation(selectedDestination.label, selectedDestination.value);
                                                        setSelectedDestinationHandler(handlerOptions);
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, offpoint: selected.label };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    placeholder="Origin"
                                                    className='autoslct'
                                                    name="origin"
                                                    value={getDestination.find(option => option.value === formData.offpoint)}
                                                />
                                            </Col>
                                            <Col sm="6">
                                                <Form.Label>Offpoint Handler Name </Form.Label>
                                                <Select
                                                    options={selectedDestinationHandler}
                                                    onChange={(selected) => {
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, offpoint_handler_id: selected.value, offpoint_handler: selected.label };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    placeholder="Handler Name"
                                                    className='autoslct'
                                                    name="offpoint_handler"
                                                    value={selectedDestinationHandler?.find(option => option.value === formData.offpoint_handler_id) || null}
                                                    isDisabled={!selectedDestinationHandler?.length}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" >
                                            <Col sm="6" className='pe-0'>
                                                <Form.Label>Scheduled Departure Time (STD)</Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    onChange={handleInputChange}
                                                    name='loading_date_planned'
                                                    value={formData.loading_date_planned}
                                                />
                                            </Col>
                                            <Col sm="6" className='pe-0'>
                                                <Form.Label>Scheduled Arrival Time (STA)</Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    onChange={handleInputChange}
                                                    name='unloading_date_planned'
                                                    value={formData.unloading_date_planned}
                                                />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="mb-1" >
                                            <Col sm="6" className='pe-0'>
                                                <Form.Label>Reference Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    onChange={handleInputChange}
                                                    name='referance_number'
                                                    value={formData.referance_number}
                                                />
                                            </Col>
                                            <Col sm="6" className='pe-0'>

                                            </Col>
                                        </Form.Group>
                                        <Form.Group className="mb-1" >
                                            <Form.Label>Remarks</Form.Label>
                                            <Form.Control as="textarea" name='remarks' value={formData.remarks || ''} onChange={handleInputChange} />
                                        </Form.Group>
                                        <Form.Group >
                                            <div className='d-flex align-items-center'>
                                                <div>
                                                    <Form.Label>Upload Documents/Images </Form.Label>
                                                    <div
                                                        className="drop_new"
                                                        onDrop={handleDrop}
                                                        onDragOver={handleDragOver}
                                                    >
                                                        <h3>Drag and drop files here</h3>
                                                        <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                                        <span>Maximum file size 4 MB</span>
                                                        <input
                                                            type="file"
                                                            ref={fileInputRef}
                                                            style={{ display: 'none' }}
                                                            onChange={handleFileChange}
                                                            multiple
                                                        />
                                                    </div>
                                                </div>
                                                <div className='d-flex upimg_repair'>
                                                    {files.map((file, index) => (
                                                        <div key={index} className='img-thumbnail'>
                                                            {file.type.startsWith('image/') ? (
                                                                <img
                                                                    src={URL.createObjectURL(file)}
                                                                    alt="Preview"
                                                                    style={{ maxWidth: '40px', maxHeight: '40px', }}
                                                                />
                                                            ) : (
                                                                <span className='d-flex'><img src={Docmnt} className='fileimg' />  </span>
                                                            )}
                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </Col>
                            <Col sm="8">
                                <div className='mb-3 nestedtabs rounded h-100'>
                                    <div className='charter_top'>
                                        <h3>Shipment Details</h3>
                                    </div>
                                    <div className='ucm_h'>
                                        <Table className='uld_details shpment_detailss'>
                                            <thead>
                                                <tr>
                                                    <th>AWB No. <span className='text-danger'>*</span></th>
                                                    <th>ULD No.</th>
                                                    <th>Pieces <span className='text-danger'>*</span></th>
                                                    <th>Weight</th>
                                                    <th>Volume</th>
                                                    <th>Nature of Goods</th>
                                                    <th>Inbound Flight No.</th>
                                                    <th>Inbound Flight Date</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData && formData.shipment.map((section, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={section?.awb_no}
                                                                    name='awb_no'
                                                                    maxLength={13}
                                                                    onChange={(e) => shipmentChange(index, 'awb_no', e.target.value)} />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={section?.uld_number}
                                                                    name='uld_number'
                                                                    onChange={(e) => shipmentChange(index, "uld_number", e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={section?.pieces}
                                                                    name='pieces'
                                                                    onChange={(e) => shipmentChange(index, "pieces", e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={section?.weight}
                                                                    name='weight'
                                                                    onChange={(e) => shipmentChange(index, "weight", e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="number"
                                                                    value={section?.volume}
                                                                    name='volume'
                                                                    onChange={(e) => shipmentChange(index, "volume", e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="text"
                                                                    value={section?.nature}
                                                                    name='nature'
                                                                    onChange={(e) => shipmentChange(index, "nature", e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <Select
                                                                        options={getOwnerCodes}
                                                                        className="autoslct"
                                                                        placeholder="Flight"
                                                                        value={getOwnerCodes.find(
                                                                            opt => opt.value === section.flight_code
                                                                        )}
                                                                        onChange={(selected) =>
                                                                            shipmentChange(index, "flight_code", selected.value)
                                                                        }
                                                                    />
                                                                    <span className="mx-1">-</span>
                                                                    <Form.Control
                                                                        type="text"
                                                                        maxLength={8}
                                                                        value={section.flight_number}
                                                                        onInput={(e) => {
                                                                            e.target.value = e.target.value
                                                                                .replace(/[^a-zA-Z0-9]/g, '')
                                                                                .slice(0, 8);
                                                                        }}
                                                                        onChange={(e) =>
                                                                            shipmentChange(index, "flight_number", e.target.value)
                                                                        }
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    type="datetime-local"
                                                                    name='flight_date'
                                                                    value={formData.flight_date}
                                                                    onChange={(e) => shipmentChange(index, "flight_date", e.target.value)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <img src={Trash} onClick={() => removeShipment(index)} />
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                        <div className='text-end'>
                                            <Button variant="primary" className='stk_add' onClick={addShipment}> <FontAwesomeIcon icon={faPlus} />Add AWB</Button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <div className='text-center mt-4 mb-4'>
                            <Button variant="light" className='stk_cancel'>CANCEL</Button>
                            <Button variant="primary" className='stk_save posr' onClick={submitForm}>UPDATE
                            </Button>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default OrderDetails